// src/components/CalendrierCreateur.jsx


import React from "react";
import { cleDate } from "../services/AgendaCreateurService";

const JOURS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

const MOIS = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

const CalendrierCreateur = ({
    annee,
    mois,              // 0 = janvier
    parJour,
    compteurs,
    selection,
    onSelect,
}) => {
    // ==================================================
    // CONSTRUCTION DE LA GRILLE
    // ==================================================

    const premierJour = new Date(annee, mois, 1);
    const nbJours = new Date(annee, mois + 1, 0).getDate();

    // getDay() : 0 = dimanche → on décale pour commencer lundi
    const decalage = (premierJour.getDay() + 6) % 7;

    const cellules = [
        ...Array(decalage).fill(null),
        ...Array.from({ length: nbJours }, (_, i) => i + 1),
    ];

    const aujourdhui = new Date();
    aujourdhui.setHours(0, 0, 0, 0);

    const memeJour = (a, b) =>
        a && b &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

    return (
        <section aria-label={`${MOIS[mois]} ${annee}`}>

            {/* ══ EN-TÊTES DES JOURS ══ */}
            <div className="grid grid-cols-7 mb-2" aria-hidden="true">
                {JOURS.map((j) => (
                    <div
                        key={j}
                        className="text-center text-xs text-gray-500
                                   font-semibold py-2"
                    >
                        {j}
                    </div>
                ))}
            </div>

            {/* ══ GRILLE ══ */}
            <div className="grid grid-cols-7 gap-1.5">
                {cellules.map((jour, i) => {
                    if (jour === null) {
                        return <div key={`vide-${i}`} aria-hidden="true" />;
                    }

                    const date = new Date(annee, mois, jour);
                    const cle = cleDate(date);

                    const evenements = parJour[cle] || [];
                    const nombre = compteurs[cle] || 0;
                    const aDesEvenements = nombre > 0;

                    const estSelectionne = memeJour(date, selection);
                    const estAujourdhui = memeJour(date, aujourdhui);
                    const estPasse = date < aujourdhui;

                    // Un événement désactivé parmi ceux du jour ?
                    const aDesactive = evenements.some((e) => !e.isActive);

                    return (
                        <button
                            key={cle}
                            type="button"
                            onClick={() => onSelect(date, evenements)}
                            aria-label={
                                aDesEvenements
                                    ? `${jour} ${MOIS[mois]} — ${nombre} événement${nombre > 1 ? "s" : ""}`
                                    : `${jour} ${MOIS[mois]} — aucun événement`
                            }
                            aria-current={estAujourdhui ? "date" : undefined}
                            className={`
                                relative aspect-square rounded-xl p-1.5
                                flex flex-col items-center justify-start
                                transition-all duration-150
                                focus:outline-none focus:ring-2
                                focus:ring-[#5F33BA] focus:ring-offset-1
                                focus:ring-offset-black
                                ${estSelectionne
                                    ? "bg-[#5F33BA] ring-2 ring-[#9B59B6]"
                                    : aDesEvenements
                                        ? "bg-white/[0.07] hover:bg-white/[0.12]"
                                        : "hover:bg-white/[0.04]"}
                                ${estPasse && !estSelectionne ? "opacity-50" : ""}
                            `}
                        >
                            {/* ── Numéro du jour ── */}
                            <span
                                className={`
                                    text-sm font-semibold
                                    ${estSelectionne
                                        ? "text-white"
                                        : estAujourdhui
                                            ? "text-[#9B59B6]"
                                            : aDesEvenements
                                                ? "text-gray-600"
                                                : "text-black"}
                                `}
                            >
                                {jour}
                            </span>

                            {/* ── Pastilles : une par événement, 3 max ── */}
                            {aDesEvenements && (
                                <div className="flex gap-0.5 mt-1 flex-wrap
                                                justify-center">
                                    {evenements.slice(0, 3).map((e, idx) => (
                                        <span
                                            key={idx}
                                            className={`
                                                w-1.5 h-1.5 rounded-full
                                                ${!e.isActive
                                                    ? "bg-gray-500"
                                                    : e.estPasse
                                                        ? "bg-blue-400"
                                                        : "bg-[#10B981]"}
                                            `}
                                        />
                                    ))}
                                </div>
                            )}

                            {/* ── Compteur si plus de 3 ── */}
                            {nombre > 3 && (
                                <span className="text-[9px] text-gray-400 mt-0.5">
                                    +{nombre - 3}
                                </span>
                            )}

                            {/* ── Aujourd'hui ── */}
                            {estAujourdhui && !estSelectionne && (
                                <span
                                    className="absolute inset-0 rounded-xl
                                               border border-[#9B59B6]/50
                                               pointer-events-none"
                                    aria-hidden="true"
                                />
                            )}

                            {/* ── Alerte si un événement est désactivé ── */}
                            {aDesactive && !estSelectionne && (
                                <span
                                    className="absolute top-1 right-1 w-1.5 h-1.5
                                               rounded-full bg-amber-500"
                                    title="Contient un événement désactivé"
                                    aria-hidden="true"
                                />
                            )}
                        </button>
                    );
                })}
            </div>
        </section>
    );
};

export default CalendrierCreateur;